import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useAvatar({ id }) {
  const [avatar, setAvatar] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.super_admins.avatars.show(id))
      .then((response) => {
        setAvatar(response.data.data);
      });
  }, [id]);

  return avatar;
}
